export default __webpack_public_path__ + "static/media/6.51b4b880.jpg";